/* global axios */
import ApiClient from './ApiClient';

class SocialPostsAPI extends ApiClient {
  constructor() {
    super('social_posts', { accountScoped: true });
  }

  // Media travels as multipart, so create/update override the JSON defaults.
  create(formData) {
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  update(id, formData) {
    return axios.patch(`${this.url}/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }

  // Sin removeFromNetworks solo se borra de Ochat, como antes. Con el, el servidor
  // intenta borrar primero de cada red y devuelve que paso en cada una.
  delete(id, { removeFromNetworks = false } = {}) {
    return axios.delete(`${this.url}/${id}`, {
      params: { remove_from_networks: removeFromNetworks },
    });
  }
}

export default new SocialPostsAPI();
